import { apiHandlerWithError } from 'api/apiHandler';

export default async function getProjectActivityLogs(id) {
  return await apiHandlerWithError(`projects/${id}/activity-logs`);
}
